import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DATA_GRID_DL_NS } from '../i18n';

export const BmtCell = ({ value }: { value: string | null | undefined }) => {
  const { t } = useTranslation(DATA_GRID_DL_NS);

  if (!value) {
    return (
      <Box alignItems="column">
        <Typography color="#8E8E93">{t('cell.noBmt')}</Typography>
      </Box>
    );
  } // Return fallback text if the date is missing

  return (
    <Box alignItems="column">
      <Typography color="#1D82C0">{value}</Typography>
    </Box>
  );
};

interface MultipleBmtCellProps {
  values: (string | null | undefined)[];
  onBmtClick?: (bmt: any, index: number) => void;
}

export const MultipleBmtCell = ({ values, onBmtClick }: MultipleBmtCellProps) => {
  const { t } = useTranslation(DATA_GRID_DL_NS);

  if (!values || values.length === 0) {
    return (
      <Typography color="#1D82C0" sx={{ fontStyle: 'italic' }}>
        {t('cell.noBmt')}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      {values.map((value, index) => (
        <React.Fragment key={index}>
          {!value || value === '' ? (
            <Typography
              onClick={(e) => {
                if (onBmtClick) {
                  e.stopPropagation();
                  onBmtClick(value, index);
                }
              }}
              sx={{ fontStyle: 'italic' }}
            >
              {t('cell.noBmt')}
            </Typography>
          ) : (
            <Typography
              color="#1D82C0"
              sx={{
                whiteSpace: 'nowrap',
                cursor: onBmtClick ? 'pointer' : 'default',
                '&:hover': onBmtClick
                  ? {
                      textDecoration: 'underline',
                    }
                  : {},
              }}
              onClick={(e) => {
                if (onBmtClick) {
                  e.stopPropagation();
                  onBmtClick(value.toString(), index);
                }
              }}
            >
              {value}
            </Typography>
          )}
          {index < values.length - 1 && (
            <Typography color="#1D82C0" sx={{ mr: 0.5 }}>
              ,
            </Typography>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};
